var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/video-call-icon.702077a5.png","uri@2x": __webpack_public_path__ + "static/media/video-call-icon.1ac00977.png","uri@3x": __webpack_public_path__ + "static/media/video-call-icon.c1c3b782.png",
    width: 28,
    height: 19
});